// extracted by css-extract-rspack-plugin
export default {"closeIcon":"TokenField-module__closeIcon___l3RPF"};